import React, { Component, ReactNode } from 'react'

import 'styles/formsy.css'
import { AFormatErrorProps } from './types'

class AFormatError extends Component<AFormatErrorProps> {
  render(): ReactNode {
    const { helperText } = this.props
    return (
      <ul className="formsy-errors-list filled d-block">
        <li className="formsy-error-item">{helperText}</li>
      </ul>
    )
  }
}

export default AFormatError
